import React, { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import { EventReqDtos } from '../../../api/interfaces/LeadsDto';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_ENDPOINTS } from '../../../api';
import { getService, postService } from '../../../servce/ApisService';
import { useLoader } from '../../../Loader/LoaderContext';
import { useToaster } from '../../../Toaster/Toaster';
import {
  getServiceyName,
  getStatusDisplayName,
} from '../../../utility/RolesUtility';
import Pagination from '../usersMangmnt/Pagination';
import DateService from '../../../servce/DateService';
type ServiceType =
  | 'COMPANY_PROFILING'
  | 'CENTER_LISTING'
  | 'BANNER_ADS'
  | 'EMAIL_MARKETING'
  | 'NEWS_LETTER_ADS'
  | 'CONTENT_MARKETING'
  | 'PRINT_AD'
  | 'EVENT_PROFILING'
  | 'EVENT_LISTING'
  | 'HOSPITAL_PROFILING';
const imageMapping: Record<ServiceType, string> = {
  COMPANY_PROFILING: '/images/Center_Listings_Profiling.svg',
  BANNER_ADS: '/images/bannerAds.svg',
  EMAIL_MARKETING: '/images/emailMarketing.svg',
  NEWS_LETTER_ADS: '/images/newsletterAd.svg',
  CONTENT_MARKETING: '/images/contentMarketing.svg',
  PRINT_AD: '/images/PrintAdvertisements.svg',
  EVENT_LISTING: '/images/eventListing.svg',
  HOSPITAL_PROFILING: '/images/PrintAdvertisements.svg',
  CENTER_LISTING: '/images/PrintAdvertisements.svg',
  EVENT_PROFILING: '/images/PrintAdvertisements.svg',
};
function ViewServiceReq() {
  const [searchParam] = useSearchParams();
  const activeVendors = searchParam.get('activeVendors');
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [totalElement, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState<string>(() => {
    return sessionStorage.getItem('searchQuery') || '';
  });

  const [currentPage, setCurrentPage] = useState<number>(() => {
    const savedPage = sessionStorage.getItem('currentPage');
    return savedPage ? parseInt(savedPage) : 0;
  });

  const { showToast } = useToaster();
  const [tableData, setTableData] = useState<any>();
  const { setLoading } = useLoader();
  const [isRefreshPage, setisRefreshPage] = useState(false);
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState<string | false>(false);
  const handleChange =
    (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
  };

  const onPageChange = async (page: any) => {
    setCurrentPage(page);
    sessionStorage.setItem('currentPage', page);
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };
  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };
  useEffect(() => {
    fetchVehicles();
    if (isRefreshPage) {
      fetchVehicles(); // Refresh data if triggered
      setisRefreshPage(false); // Reset the refresh trigger
    }
  }, [isRefreshPage, searchQuery, currentPage]);
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('appUserId');
  const fetchVehicles = async () => {
    setLoading(true);
    let body: any;
    try {
      let url: any;

      let body = {
        appUserId: userId,
        search: searchQuery,
        pahe: currentPage,
      };
      if (activeVendors == 'activevendors') {
        url = API_ENDPOINTS.getActiveServiceReq + '?proposalId=' + userId;
      } else {
        if (userInfo.roles === 'SALES_MANAGER') {
          url = API_ENDPOINTS.getSMServicereq + '?leadId=' + userId;
        } else if (userInfo.roles === 'SALES_ADMIN') {
          url = API_ENDPOINTS.gerServiceReq + '?leadId=' + userId;
        } else if (userInfo.roles === 'SALES_TEAM_LEAD') {
          url = API_ENDPOINTS.getTlServiceReq + '?leadId=' + userId;
        } else if (userInfo.roles === 'SALES_EXECUTIVE') {
          url = API_ENDPOINTS.getSEServicereq + '?leadId=' + userId;
        }
      }
      const response = await getService(url);
      setTimeout(() => {
        setTableData(response.data);
        setTotalPages(response.data?.totalPages);
        setTotalElements(response.data?.totalElements);
      }, 300);
      setTimeout(() => {
        setLoading(false);
      }, 500);
    } catch (error) {
      setTimeout(() => {
        setLoading(false);
      }, 500);
      showToast('error', 'error', '');
      console.error('Error fetching vehicle data:', error);
    } finally {
    }
  };
  const viewLeads = () => {
    if (activeVendors == 'proposals') {
      navigate('/portals/proposals/viewProposal');
    } else if (activeVendors == 'activevendors') {
      navigate('/portals/vendors/activeVendor');
    } else if (activeVendors == 'inactivevendors') {
      navigate('/portals/vendors/inActiveVendor');
    } else {
      navigate('/portals/leads/viewUser');
    }
  };
  const back = () => {
    navigate(-1);
  };
  const name = searchParams.get('firstName')?.replace(/-/g, ' ');
  return (
    <div className='h-full py-2 w-full relative'>
      <div className='flex items-center mb-4'>
        <h2
          className='mr-2 text-gray-700 font-semibold text-sm  cursor-pointer'
          onClick={viewLeads}
        >
          {activeVendors == 'proposals'
            ? 'Proposals'
            : activeVendors == 'activevendors'
            ? 'Active Vendors'
            : activeVendors == 'inactivevendors'
            ? 'Inactive Vendors'
            : 'Leads'}
        </h2>
        <>
          <span className='mr-2 flex items-center'>
            <img src='/images/arrowIcons.svg' className='mr-2' />
            <span className='text-gray-400 font-semibold text-sm mr-2'>
              {activeVendors == 'proposals'
                ? 'View Proposals'
                : activeVendors == 'activevendors'
                ? 'View Active Vendors'
                : activeVendors == 'inactivevendors'
                ? 'View Inactive Vendors'
                : 'View Leads'}{' '}
            </span>
          </span>
        </>
      </div>
      <div className='flex items-center  mt-2' onClick={viewLeads}>
        <img src='/images/back.svg' className='mr-2 cursor-pointer' />
        <h1 className='text-2xl font-bold text-[#2D2E2F]'>
          {tableData?.type == 'CALLBACK'
            ? 'Called Back Info'
            : 'Requested  info'}
        </h1>
      </div>
      <div className='mt-4'>
        {/* <> */}
        {tableData?.map((item: any, index: number) => (
          <div className='mb-3 bg-white' key={index}>
            <Accordion
              key={item?.id}
              expanded={expanded === `panel${index}`}
              onChange={handleChange(`panel${index}`)}
              className='accordion-root'
              style={{ boxShadow: 'none' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
                className='accordion-summary text-lg font-semibold'
                style={{
                  backgroundColor: 'white',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography
                  className='text-lg font-semibold text-[#B00A2B] px-3'
                  style={{ fontWeight: '600', fontSize: '18px' }}
                >
                  Request {index + 1} (
                  {item?.type == 'CALLBACK'
                    ? 'Requested Callback'
                    : 'Requested Email Response'}
                  )
                </Typography>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'end',
                    flexGrow: 1,
                  }}
                >
                  <Typography
                    className='text-lg font-semibold px-3 text-gray-900'
                    style={{ fontWeight: '600', fontSize: '18px' }}
                  >
                    Submitted on:{' '}
                    <span className='font-semibold text-base'>
                      {item?.submittedDate
                        ? DateService.formatDate(
                            item?.submittedDate,
                            DateService.formats.DD_MM_YYYY
                          )
                        : 'NA'}
                    </span>
                  </Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails className='accordion-details bg-white border-t border-gray-100 p-2'>
                <Typography component={'div'}>
                  {/* Form details go here */}
                  <div className='form-group mb-4 mt-3 px-3'>
                    {/* <h3 className="text-gray-900 font-semibold text-2xl">
                      Services
                    </h3> */}
                    <div className='grid grid-cols-3 py-5 px-2 gap-5'>
                      {item?.serviceReqDtos?.map((item: any) => (
                        <div className='flex items-center'>
                          <div className='bg-[#FFEEEF] rounded-[11px] flex items-center justify-center mr-3.5 p-2 w-[60px] h-[60px]'>
                            <img
                              src={
                                imageMapping[item?.serviceType as ServiceType]
                              } // Type assertion here
                              alt={item}
                              className=''
                            />
                          </div>
                          <p className='text-gray-800 font-bold text-base'>
                            {getStatusDisplayName(item?.serviceType)}
                          </p>
                        </div>
                      ))}
                    </div>
                    <h3 className='text-gray-900 font-semibold text-2xl border-t border-gray-100 pb-4 pt-5'>
                      Details
                    </h3>
                    <div className='border border-gray-200 rounded-[10px] p-4'>
                      <div className='grid grid-cols-3 px-4 py-5 gap-5'>
                        <div className=''>
                          <h2 className='text-gray-700 font-normal text-sm'>
                            Contact Person Name
                          </h2>
                          <p className='text-base font-semibold text-gray-900 mt-1'>
                            {item?.contactPersonName || 'NA'}
                          </p>
                        </div>
                        <div className=''>
                          <h2 className='text-gray-700 font-normal text-sm'>
                            Email Address
                          </h2>
                          <p className='text-base font-semibold text-gray-900 mt-1'>
                            {item?.email || 'NA'}
                          </p>
                        </div>
                        <div className=''>
                          <h2 className='text-gray-700 font-normal text-sm'>
                            Contact Number
                          </h2>
                          <p className='text-base font-semibold text-gray-900 mt-1'>
                            {item?.phoneNumber || 'NA'}
                          </p>
                        </div>
                        <div className=''>
                          <h2 className='text-gray-700 font-normal text-sm'>
                            Country
                          </h2>
                          <p className='text-base font-semibold text-gray-900 mt-1'>
                            {item?.mtCountryDto?.name || 'NA'}
                          </p>
                        </div>
                        <div className=''>
                          <h2 className='text-gray-700 font-normal text-sm'>
                            Preferable date for callback
                          </h2>
                          <p className='text-base font-semibold text-gray-900 mt-1'>
                            {item?.date || 'NA'}
                          </p>
                        </div>
                        <div className=''>
                          <h2 className='text-gray-700 font-normal text-sm'>
                            Preferable time for callback
                          </h2>
                          <p className='text-base font-semibold text-gray-900 mt-1'>
                            {item?.time || 'NA'}
                          </p>
                        </div>
                      </div>
                      <div className='grid grid-cols-1'>
                        <div className=''>
                          <h2 className='text-gray-700 font-normal text-sm'>
                            Enquiry Details
                          </h2>
                          <p className='text-base font-semibold text-gray-900 mt-1 break-words'>
                            {item?.enquiryDetails || 'NA'}
                          </p>
                        </div>
                      </div>

                      {/* <p className='text-[#B00A2B] font-semibold text-base mt-3 px-4'>Posted on: {item?.submittedOn}</p> */}
                    </div>
                  </div>
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
        ))}
        {!tableData?.length && (
          <div className='px-3.5 md:px-20 py-8 text-center'>
            <div className='text-center'>
              <div className='flex justify-center'>
                <img src='/images/emptyData.svg' alt='' />
              </div>
              <p className='text-[#667085] text-[24px] font-semibold mt-5'>
                No Data Found
              </p>
            </div>
          </div>
        )}

        {/* </> */}
      </div>
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalElement={totalElement}
          onPageChange={onPageChange}
          onNext={onNext}
          onPrevious={onPrevious}
        />
      )}
    </div>
  );
}
export default ViewServiceReq;
